<template>
    <div v-if="team && league">
        <TeamSubNavigation :team="team" :league="league" :baseUrl="baseUrl" :removeMargin="true"></TeamSubNavigation>


        <div class="container" v-if="topScorerStatistics && topScorerStatistics.length > 0">
            <div class="grid">

                <!-- Mobile -->
                <div class="col-12 hidden-sm-up">

                    <div class="stepper">
                        <div @click="mobileStatisticsTab = Math.max(1, mobileStatisticsTab - 1)" class="stepper__button stepper__button--left"></div>
                        <div class="stepper__title">
                            {{ mobileStatisticsList.find(el => el.id == mobileStatisticsTab).name }}
                        </div>
                        <div @click="mobileStatisticsTab = Math.min(mobileStatisticsList.length, mobileStatisticsTab + 1)" class="stepper__button stepper__button--right"></div>
                    </div>

                    <PlayerStatisticsTile v-if="mobileStatisticsTab == 1" :data="topScorerStatistics" :statisticyType="'topScorer'" mainKey="goals" mainLabel="Tor|Tore" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 2" :data="topScorerStatistics" :statisticyType="'topScorer'" mainKey="fieldGoals" mainLabel="Tor|Tore" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 3" :data="topScorerStatistics" :statisticyType="'topScorer'" mainKey="sevenMeterGoals" mainLabel="Tor|Tore" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 4" :data="topScorerStatistics" :statisticyType="'topScorer'" mainKey="avgGoals" mainLabel="Tor|Tore" :competitionId="leagueId"></PlayerStatisticsTile>

                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 5" :data="topSavesStatistics" :statisticsType="'topSaves'" mainKey="saves" mainLabel="Parade|Paraden" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 6" :data="topSavesStatistics" :statisticsType="'topSaves'" mainKey="_avgSaves" mainLabel="Parade|Paraden" :competitionId="leagueId"></PlayerStatisticsTile>

                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 7" :data="topAssistsStatistics" :statisticsType="'topAssists'" mainKey="assists" mainLabel="Assist|Assists" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 8" :data="topAssistsStatistics" :statisticsType="'topAssists'" mainKey="_avgAssists" mainLabel="Assist|Assists" :competitionId="leagueId"></PlayerStatisticsTile>
                   
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 9" :data="topSinnersStatistics" :statisticsType="'topSinners'" mainKey="twoMinutePenalties" mainLabel="Strafe|Strafen" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 10" :data="topSinnersStatistics" :statisticsType="'topSinners'" mainKey="red_cards" mainLabel="Karte|Karten" :competitionId="leagueId"></PlayerStatisticsTile>
                    <PlayerStatisticsTile v-else-if="mobileStatisticsTab == 11" :data="topSinnersStatistics" :statisticsType="'topSinners'" mainKey="yellow_cards" mainLabel="Karte|Karten" :competitionId="leagueId"></PlayerStatisticsTile>

                </div>

                <!-- Desktop -->
                <div class="col-12 hidden-xs-down">

                    <div class="section">

                        <div class="section__title">
                            <h2>Alle Statistiken</h2>
                            <ul class="section__title__tabs">
                                <li :class="activeStatisticsTab == 1 ? ' is-active' : ''" @click="activeStatisticsTab = 1">Tore</li>
                                <li :class="activeStatisticsTab == 2 ? ' is-active' : ''" @click="activeStatisticsTab = 2">Paraden</li>
                                <li :class="activeStatisticsTab == 3 ? ' is-active' : ''" @click="activeStatisticsTab = 3">Assists</li>
                                <li :class="activeStatisticsTab == 4 ? ' is-active' : ''" @click="activeStatisticsTab = 4">Strafen</li>
                            </ul>
                        </div>

                        <PlayerStatisticsTable v-if="activeStatisticsTab == 1" :statistics="topScorerStatistics" :properties="topScorerProperties" :competitionId="leagueId"></PlayerStatisticsTable>
                        <PlayerStatisticsTable v-if="activeStatisticsTab == 2" :statistics="topSavesStatistics" :properties="topSavesProperties" :competitionId="leagueId"></PlayerStatisticsTable>
                        <PlayerStatisticsTable v-if="activeStatisticsTab == 3" :statistics="topAssistsStatistics" :properties="topAssistsProperties" :competitionId="leagueId"></PlayerStatisticsTable>
                        <PlayerStatisticsTable v-if="activeStatisticsTab == 4" :statistics="topSinnersStatistics" :properties="topSinnersProperties" :competitionId="leagueId"></PlayerStatisticsTable>

                    </div>

                </div>
            </div> <!-- Close .grid -->
        </div> <!-- Close .container -->

        <!-- Statistics Empty -->
        <div class="container" v-else>
            <div class="grid">
                <div class="col-12">
                    <StatisticsEmpty description="Das erste Saisonspiel des Teams steht noch bevor."/>
                </div>
            </div>
        </div>

    </div>
    
</template>
<script>
import TeamSubNavigation from '@/components/TeamSubNavigation.vue';
import PlayerStatisticsTile from '@/components/PlayerStatisticsTile.vue';
import StatisticsEmpty from '@/components/StatisticsEmpty.vue';
import PlayerStatisticsTable from '@/components/PlayerStatisticsTable.vue';

export default {
    name: 'TeamStatisticsView',
    components: {
        TeamSubNavigation,
        PlayerStatisticsTable,
        PlayerStatisticsTile,
        StatisticsEmpty,
    },
    data() {
        return {
            options: {
                arrows: false,
                pagination: false,
                gap: '8px',
                padding: '24px'
            },
            teamId: null,
            leagueId: null,
            competitions: null,
            league: null,
            detailData: null,
            team: null,
            seasonInfo: null,
            topScorerProperties: [
                {"id": 1, "key": "goals", title: "Gesamt"},
                {"id": 2, "key": "fieldGoals", title: "Feld"},
                {"id": 3, "key": "sevenMeterGoals", title: "7-Meter"},
                {"id": 4, "key": "avgGoals", title: "Ø Spiel"}
            ],
            topSavesProperties: [
                {"id": 1, "key": "saves", title: "Gesamt"},
                {"id": 2, "key": "_avgSaves", title: "Ø Spiel"},
            ],
            topAssistsProperties: [
                {"id": 1, "key": "assists", title: "Gesamt"},
                {"id": 2, "key": "_avgAssists", title: "Ø Spiel"},
            ],
            topSinnersProperties: [
                {"id": 1, "key": "twoMinutePenalties", title: "2 Min"},
                {"id": 2, "key": "red_cards", title: "Rot"},
                {"id": 3, "key": "yellow_cards", title: "Gelb"},

            ],
            activeStatisticsTab: 1,
            mobileStatisticsList: [
                {id: 1, name: "Tore (Gesamt)"},
                {id: 2, name: "Tore (Feld)"},
                {id: 3, name: "Tore (7-Meter)"},
                {id: 4, name: "Tore (Ø Spiel)"},

                {id: 5, name: "Paraden (Gesamt)"},
                {id: 6, name: "Paraden (Ø Spiel)"},

                {id: 7, name: "Assists (Gesamt)"},
                {id: 8, name: "Assists (Ø Spiel)"},

                {id: 9, name: "2 Min."},
                {id: 10, name: "Rote Karten"},
                {id: 11, name: "Gelbe Karten"},
            ],
            mobileStatisticsTab: 1,
            topScorerStatistics: null,
            topSavesStatistics: null,
            topSinnersStatistics: null,
            topAssistsStatistics: null,
        };
    },
    methods: {
        init(teamId, leagueId) {
            this.teamId = parseInt(teamId);
            this.leagueId = parseInt(leagueId);

            this.$store.dispatch("fetchCompetitions").then( () => {
                this.competitions = this.$store.getters.getCompetitions;
                this.league = this.competitions.find(el => el.id == this.leagueId);

                if (this.league) {
                    this.$store.dispatch("fetchData",  {filename: "leagues/league_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                        this.detailData = res;
                        var season_key = this.league.fmpSeasonId;
                        this.seasonInfo = this.detailData.seasons.find(s => s.fmpSeasonId == season_key);
                        this.team = this.detailData.teams.find(t => t.fmpTeamId == this.teamId);

                    });

                    this.fetchStatistics();
                }
            });
        },
        fetchStatistics() {
            this.$store.dispatch("fetchData",  {filename: "players/players_" + this.league.fmpSeasonId + ".json"}).then( (res) => {
                if (res.playerStatistics == null) { return; }
                this.activeStatisticsTab = 1;

                res.playerStatistics.forEach(s => {
                    s.avgGoals = s.avgGoals.toFixed(1);
                    if (s.totalMatches > 0) {
                        s._avgAssists = (s.assists / s.totalMatches).toFixed(1);
                        s._avgSaves = (s.saves / s.totalMatches).toFixed(1);
                    }
                });
                this.topScorerStatistics = res.playerStatistics.filter(s => s.fmpTeamId == this.teamId && s.goals > 0);
                this.topSavesStatistics = res.playerStatistics.filter(s => s.fmpTeamId == this.teamId && s.saves > 0 && s.position == "goalkeeper");
                this.topSinnersStatistics = res.playerStatistics.filter(s => s.fmpTeamId == this.teamId && (s.yellow_cards > 0 || s.red_cards > 0 || s.twoMinutePenalties > 0));
                this.topAssistsStatistics = res.playerStatistics.filter(s => s.fmpTeamId == this.teamId && s.assists > 0);

            });
        }
    },
    mounted () {
        this.init(this.$route.params.id, this.$route.params.leagueId);
    },
    beforeRouteUpdate (to, from, next) {
        this.init(to.params.id, to.params.leagueId);
        next();
    },
    computed: {
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>
